import { render } from "./terms-condition-scr.vue?vue&type=template&id=eb975334&scoped=true"
import script from "./terms-condition-scr.vue?vue&type=script&lang=js"
export * from "./terms-condition-scr.vue?vue&type=script&lang=js"

import "./terms-condition-scr.vue?vue&type=style&index=0&id=eb975334&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb975334"]])

export default __exports__